import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../PageHeader';
import { IPD_COLORS } from '../../theme';

/**
 * Standard layout wrapper for Material Management master list pages.
 */
export default function MaterialMasterShell({ title, description, badge, actions, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, color: IPD_COLORS.textPrimary }}>
      <PageHeader
        eyebrow="Material Management"
        title={title}
        description={description}
        badge={badge}
        actions={actions}
      />
      {children}
    </Box>
  );
}
